// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import { errorErrorsList } from 'redux/modules/notifications'
import { castToFloat } from 'helpers/reduxFormFunctions'
import { updateInterferenceAnalysisState } from 'redux/modules/interferenceAnalysis/actions'
import parseAnalysisResults from 'redux/modules/interferenceAnalysis/thunks/parseAnalysisResults'
import { assembleQuery } from 'helpers/api/meta'
import { fetchProjectAnalysisAFSGrid } from 'helpers/api/project'

import {
  AFS_GRID_FILTER,
  AFS_GRID_RESULTS,
} from 'redux/modules/interferenceAnalysis/constants'

// since the filter's bandId determines which set of results we are going to get,
// we then fetch the analysis results for the given
// projectId && bandId && analysisTypeId

// NOTE - this thunk fetches analysis results
// separates the data for redux-form (so user can select polarization configurations)
// and places the rest of the data in interferenceAnalysis redux state since these
// values can not be mutated by the user.

const getAnalysisResults = () => async (dispatch, getState) => {
  const {
    form,
    projectSummary,
  } = getState()

  const projectId = projectSummary.get('projectId')

  const formValues = form[AFS_GRID_FILTER].values

  const analysisTypeId = castToFloat(formValues.analysisTypeId)
  const applyResultFilter = formValues.applyResultFilter
  const bandId = castToFloat(formValues.bandId)

  const query = assembleQuery([{
    field: 'analysisTypeId',
    value: analysisTypeId,
  }, {
    field: 'filter',
    value: applyResultFilter,
  }, {
    field: 'bandId',
    value: bandId,
  }])

  try {
    const { entity } = await fetchProjectAnalysisAFSGrid(projectId, query)

    const {
      groupedFrequencyPlans,
      gridInitialValues,
    } = await dispatch(parseAnalysisResults(entity))

    // initialize the form aspect of the results grid.
    await dispatch(initialize(AFS_GRID_RESULTS, gridInitialValues))

    // update the interferenceAnalysis redux state portion of the results grid
    await dispatch(updateInterferenceAnalysisState({
      groupedFrequencyPlans,
      analysisStatusId: entity.analysisStatus?.analysisStatusId || null,
    }))
  } catch (err) {
    console.warn(err)
    dispatch(errorErrorsList(err))
  }
}

export default getAnalysisResults
